import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="document-ban"
export default class extends Controller {
  static targets = ["icon"]

  connect() {
    // console.log("Document ban controller connected")
  }

  async banIdentifier(event) {
    const icon = event.currentTarget
    const identifier = icon.dataset.identifier
    const identifierType = icon.dataset.identifierType
    const countryCode = icon.dataset.countryCode
    const documentId = icon.dataset.documentId
    
    if (!identifier || !identifierType || !documentId) {
      console.error("Missing required data attributes for ban operation")
      return
    }
    
    // Allow country code to be null/empty
    
    if (!confirm(`Are you sure you want to add ${identifier} to the blocklist?\nThis action cannot be undone.`)) {
      return
    }
    
    try {
      icon.classList.remove('fa-ban')
      icon.classList.add('fa-spinner', 'fa-spin')
      
      // Use Rails route helper path from data attribute
      const url = icon.dataset.banUrl || `/dashboard/document/${documentId}/ban_identifier`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          identifier: identifier,
          identifier_type: identifierType,
          country_code: countryCode
        })
      })
      
      const result = await response.json()
      
      if (result.success) {
        // Change the icon to indicate success
        icon.classList.remove('fa-spinner', 'fa-spin')
        icon.classList.add('fa-check', 'text-success')
        
        // Disable the icon
        icon.style.cursor = 'default'
        icon.onclick = null
        
        // Show success toast
        if (window.BynnToast) {
          window.BynnToast.success(result.message || `Added '${identifier}' to blocklist successfully`)
        }
        
        // If you have a flash container in your layout, this will update automatically
        // from the server-side flash message
      } else {
        throw new Error(result.error || "Failed to add to blocklist")
      }
    } catch (error) {
      console.error("Error adding to blocklist:", error)
      
      // Restore the icon
      icon.classList.remove('fa-spinner', 'fa-spin')
      icon.classList.add('fa-ban')
      
      // Show error toast
      if (window.BynnToast) {
        window.BynnToast.error(`Failed to add '${identifier}' to blocklist: ${error.message}`)
      }
    }
  }
}